import request from '@/utils/request'

/**
 * 查询退货单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核退货单
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/auditInoutOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0 || response.status === 200) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除退货单
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/deleteInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}